export const EMAILREGEX = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;
export const EMAILORNUMBERREGEX =
  // eslint-disable-next-line max-len
  /^(?:\d+|[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
export const APLHANUMERIC = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]/;
export const ONLYNUMBER = /^\d+$/;
export const ONLYLETTER = /[a-zA-Z]/;
